import axios from 'axios';
import { Dispatch } from 'react-redux';

import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import * as alertActions from './alertActions';
import { navigateToAffiliateProgramPartners } from './navigationActions';

import ResponseStatus from '../utils/responseStatus';
import affiliateProgramPartnersItemTransformationBeforeSave from '../data-transformations/affiliateProgramPartnersItemTransformationBeforeSave';
import { isLoaded } from '../reducers/affiliateProgramPartnersReducer';

export const fetchAffiliateProgramPartners = () => async (dispatch: Dispatch<any>, getState: any) => {
    if (isLoaded(getState())) {
        return;
    }

    try {
        dispatch(beginAjaxCall());

        const response = await axios.get(`affiliateProgramPartner/`);

        if (ResponseStatus.IsOK(response.status)) {
            dispatch({
                type: types.AFFILIATE_PROGRAM_PARTNERS_FETCH,
                data: response.data,
            });
        } else {
            dispatch(ajaxCallError());
        }
    } catch (error) {
        dispatch(ajaxCallError());
        throw error;
    }
};

export const createAffiliateProgramPartner = (data: any) => (dispatch: Dispatch<any>) => {
    dispatch(beginAjaxCall());

    const transformedData = affiliateProgramPartnersItemTransformationBeforeSave(data);

    axios
        .post(`affiliateProgramPartner`, transformedData)
        .then((response) => {
            if (ResponseStatus.IsCreated(response.status)) {
                dispatch({
                    type: types.NEWS_ADD,
                });

                dispatch(navigateToAffiliateProgramPartners());
            } else {
                dispatch(ajaxCallError());
            }
        })
        .catch((error) => {
            dispatch(ajaxCallError());
            throw error;
        });
};

export const updateAffiliateProgramPartner = (data: any) => (dispatch: Dispatch<any>) => {
    dispatch(beginAjaxCall());

    const transformedData = affiliateProgramPartnersItemTransformationBeforeSave(data);

    axios
        .put(`affiliateProgramPartner`, transformedData)
        .then((response) => {
            if (ResponseStatus.IsOK(response.status)) {
                dispatch({
                    type: types.NEWS_UPDATE,
                    data: response.data,
                });

                dispatch(navigateToAffiliateProgramPartners());
            } else {
                dispatch(ajaxCallError());
            }
        })
        .catch((error) => {
            dispatch(ajaxCallError());
            throw error;
        });
};
